// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"export-result-upload__wrapper-2o0DA","fileUploadButton":"export-result-upload__fileUploadButton-2Jbir blocks__big-2DxLx blocks__white-2DChO blocks__button-1iODk","fileUploadButtonLabel":"export-result-upload__fileUploadButtonLabel-2R7WU","fileResultUploadInput":"export-result-upload__fileResultUploadInput-98EtA","uploadFailTooltip":"export-result-upload__uploadFailTooltip-SKtJS blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/export-result-upload/styles.css
// module id = 759
// module chunks = 0